// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1jLDq","label":"Completed_label__1uJUP"};